import GraphQLTextResult from '../../graphQLTextResult'
import toSnakeCase from '../../../util/toSnakeCase'
import { gql } from '@polleverywhere/graphql-client'

const moderateDiscourseResult = gql`
  mutation moderateDiscourseResult($input: ModerateResultInput!) {
    moderateDiscourseResult(input: $input) {
      approved
    }
  }
`

export default class Result extends GraphQLTextResult {
  getQuery (action) {
    switch (action) {
      case 'patch':
        return {
          action: 'mutate',
          parse: (json) => toSnakeCase(json.moderateDiscourseResult),
          query: moderateDiscourseResult,
          variables: {
            input: {
              presenterKey: this.poll().get('presenter_key'),
              resultId: this.get('id'),
              approved: this.get('approved')
            }
          }
        }
      default:
        throw new Error(`Unknown query for ${action}`)
    }
  }

  initialize (...args) {
    super.initialize(...args)
    // Alias' - not sure why we have these, but we do
    this.unapprove = this.reject
    this.isUnapproved = this.isRejected
  }

  feature () {
    return this.poll().featureResult(this.id)
  }

  unfeature () {
    return this.poll().featureResult(null)
  }

  approve () {
    return this.save({ approved: true }, { patch: true })
  }

  reject () {
    return this.save({ approved: false }, { patch: true })
  }
}
